import { useEffect, useRef } from 'react';

/**
 * Runs an effect after a debounce delay and cleans up safely on deps change/unmount.
 */
export function useDebouncedEffect(effectFn, deps, delayMs) {
  const effectCleanupRef = useRef(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const cleanup = effectFn();
      effectCleanupRef.current = typeof cleanup === 'function' ? cleanup : null;
    }, delayMs);

    return () => {
      clearTimeout(timeoutId);
      if (effectCleanupRef.current) {
        effectCleanupRef.current();
        effectCleanupRef.current = null;
      }
    };
  }, [delayMs, ...deps]);
}
